import {
  AppstoreOutlined, AuditOutlined, BookOutlined, CalendarOutlined, ContainerOutlined,
  DashboardOutlined, FileProtectOutlined, FormOutlined, FundOutlined,
  MessageOutlined, MoneyCollectOutlined, NotificationOutlined, OrderedListOutlined,
  QuestionCircleOutlined, SafetyCertificateOutlined, SettingOutlined, SolutionOutlined,
  TeamOutlined, UserOutlined, VideoCameraOutlined,
} from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { appRoutes } from '@/app/routes'

const menuItems: MenuProps['items'] = [
  { key: '/', icon: <DashboardOutlined aria-hidden="true" />, label: '工作台' },
  { key: 'identity', icon: <TeamOutlined aria-hidden="true" />, label: '账号管理', children: [
    { key: '/users', icon: <UserOutlined aria-hidden="true" />, label: '用户管理' },
    {key:'/organization-applications',icon:<AuditOutlined aria-hidden="true" />,label:'团队申请'},
    {key:'/organizations',icon:<TeamOutlined aria-hidden="true" />,label:'团队管理'},
    { key: '/teachers', icon: <SolutionOutlined aria-hidden="true" />, label: '教师管理' },
  ] },
  { key: 'course', icon: <BookOutlined aria-hidden="true" />, label: '课程管理', children: [
    { key: '/courses', icon: <OrderedListOutlined aria-hidden="true" />, label: '课程管理' },
    { key: '/course-categories', icon: <AppstoreOutlined aria-hidden="true" />, label: '课程分类' },
  ] },
  { key: 'classroom', icon: <VideoCameraOutlined aria-hidden="true" />, label: '教学运营', children: [
    { key: '/classrooms', icon: <CalendarOutlined aria-hidden="true" />, label: '课堂管理' },
    { key: '/course-groups', icon: <TeamOutlined aria-hidden="true" />, label: '课程群管理' },
    { key: '/group-reports', icon: <MessageOutlined aria-hidden="true" />, label: '群聊举报' },
  ] },
  { key: 'trade', icon: <MoneyCollectOutlined aria-hidden="true" />, label: '交易与财务', children: [
    { key: '/wallets', icon: <MoneyCollectOutlined aria-hidden="true" />, label: '资金流水' },
    { key: '/orders', icon: <ContainerOutlined aria-hidden="true" />, label: '订单管理' },
    { key: '/refunds', icon: <AuditOutlined aria-hidden="true" />, label: '退款审核' },
    { key: '/teacher-income', icon: <FundOutlined aria-hidden="true" />, label: '教师收益与提现' },
    { key: '/settlements', icon: <FundOutlined aria-hidden="true" />, label: '教师结算' },
  ] },
  { key: 'learning', icon: <FormOutlined aria-hidden="true" />, label: '教学内容治理', children: [
    { key: '/assignments', icon: <FileProtectOutlined aria-hidden="true" />, label: '作业管理' },
    { key: '/questionnaires', icon: <QuestionCircleOutlined aria-hidden="true" />, label: '问卷管理' },
  ] },
  { key: 'operations', icon: <NotificationOutlined aria-hidden="true" />, label: '运营与服务', children: [
    { key: '/gifts', icon: <NotificationOutlined aria-hidden="true" />, label: '直播礼物' },
    { key: '/banners', icon: <NotificationOutlined aria-hidden="true" />, label: '首页 Banner' },
    { key: '/operations', icon: <NotificationOutlined aria-hidden="true" />, label: '运营通知' },
    { key: '/support-tickets', icon: <MessageOutlined aria-hidden="true" />, label: '用户反馈' },
  ] },
  { key: 'system', icon: <SafetyCertificateOutlined aria-hidden="true" />, label: '系统治理', children: [
    { key: '/admin-members', icon: <UserOutlined aria-hidden="true" />, label: '管理员管理' },
    { key: '/roles', icon: <SafetyCertificateOutlined aria-hidden="true" />, label: '角色与权限' },
    { key: '/audit-logs', icon: <AuditOutlined aria-hidden="true" />, label: '操作审计' },
    { key: '/health', icon: <DashboardOutlined aria-hidden="true" />, label: '系统监控' },
    { key: '/settings', icon: <SettingOutlined aria-hidden="true" />, label: '系统设置' },
  ] },
]

const permissionByPath = Object.fromEntries(
  appRoutes.filter((route) => !route.path.includes('/:')).map((route) => [route.path, route.permission]),
) as Record<string, string | undefined>

export const navigationGroupByPath: Record<string, { key: string; label: string }> = {
  '/organizations':{key:'identity',label:'账号管理'},'/organization-applications':{key:'identity',label:'账号管理'},
  '/users': { key: 'identity', label: '账号管理' }, '/teachers': { key: 'identity', label: '账号管理' },
  '/courses': { key: 'course', label: '课程管理' }, '/course-categories': { key: 'course', label: '课程管理' },
  '/classrooms': { key: 'classroom', label: '教学运营' }, '/course-groups': { key: 'classroom', label: '教学运营' }, '/group-reports': { key: 'classroom', label: '教学运营' },
  '/wallets': { key: 'trade', label: '交易与财务' }, '/orders': { key: 'trade', label: '交易与财务' }, '/refunds': { key: 'trade', label: '交易与财务' }, '/teacher-income': { key: 'trade', label: '交易与财务' }, '/settlements': { key: 'trade', label: '交易与财务' },
  '/assignments': { key: 'learning', label: '教学内容治理' }, '/questionnaires': { key: 'learning', label: '教学内容治理' },
  '/gifts': { key: 'operations', label: '运营与服务' },
  '/banners': { key: 'operations', label: '运营与服务' },
  '/operations': { key: 'operations', label: '运营与服务' }, '/support-tickets': { key: 'operations', label: '运营与服务' },
  '/admin-members': { key: 'system', label: '系统治理' }, '/roles': { key: 'system', label: '系统治理' }, '/audit-logs': { key: 'system', label: '系统治理' }, '/health': { key: 'system', label: '系统治理' }, '/settings': { key: 'system', label: '系统治理' },
}

export function buildMenuItems(can: (permission?: string) => boolean): MenuProps['items'] {
  return menuItems?.flatMap((item) => {
    if (!item || !('key' in item)) return []
    const key = String(item.key)
    if ('children' in item && item.children) {
      const children = item.children.filter((child) => child && 'key' in child && can(permissionByPath[String(child.key)]))
      return children.length ? [{ ...item, children }] : []
    }
    return can(permissionByPath[key]) ? [item] : []
  })
}
